import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Badge } from '@lightspeed/flame/Badge';
import Text from '@lightspeed/cirrus-text';
import { color, spacing, radius } from '@lightspeed/cirrus-tokens/utils';

import {
  COLOR_SIDEBAR_SECONDARY_BUTTON_BG,
  COLOR_SIDEBAR_SECONDARY_BUTTON_BG_HOVER,
} from '@lightspeed/cirrus-sidebar/dist/styles/constants';

export const activeStyle = css`
  background-color: ${COLOR_SIDEBAR_SECONDARY_BUTTON_BG_HOVER};
`;

export const TimeclockLink = styled('a')`
  display: inline-block;
  text-align: right;
  max-width: 80px;
  padding: calc(${spacing(2)} - 1px) ${spacing(1)};
  margin: ${spacing(1)} ${spacing(2)} ${spacing(1)} 0;
  transition: background-color 50ms;
  border-radius: ${radius(1)};
  border: 0;
  cursor: pointer;
  &:hover,
  &:focus {
    background-color: ${COLOR_SIDEBAR_SECONDARY_BUTTON_BG};
  }
  &:active {
    ${activeStyle};
  }
`;

export const TimeclockBadge = styled(Badge)`
  vertical-align: text-bottom;
  color: ${color('dive')};
`;

export const TimeclockText = styled(Text)`
  vertical-align: text-bottom;
  display: inline-block;
  margin-left: ${spacing(1)};
  color: ${color('green-200')};
`;
